import React, { MutableRefObject, useEffect, useState } from 'react'
import { Box } from '../../../CustomUi/box'
import Input from '../../../CustomUi/input'
import { Switcher } from '../../../CustomUi/Switcher'
import AntdCrop from 'antd-img-crop'
import { Button, Empty, Upload, UploadFile } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { UploadChangeParam } from 'antd/lib/upload'
import { UploadRequestOption } from 'rc-upload/lib/interface'
import { HeaderTable } from '../../../CustomUi/table/headerTable'
import { BodyTable } from '../../../CustomUi/table/bodyTable'
import { Render } from '../../../CustomUi/render'
import { RowTable } from '../../../CustomUi/table/rowTable'
import { RowItem } from '../../../CustomUi/table/rowItem'
import Carregando from '../../../CustomUi/loading'
import ButtonCustom from '../../../ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCheck,
  faClipboardList,
  faFileSignature,
  faPen,
  faPercent,
  faPlus,
  faUser,
} from '@fortawesome/free-solid-svg-icons'
import { Select } from '../../../CustomUi/Select'
import {
  delRepresentanteLegal,
  getRepresentanteLegal,
} from '../../../../services/RepresentanteLegal'
import { DeleteButton } from '../../../CustomUi/deleteButton'
import { update } from 'lodash'
import { successAlert } from '../../../../utils/alert'
import TextArea from '../../../CustomUi/textarea'
import { apenasNumeros } from '../../../../utils'

interface PropsRepresentantes {
  nome_usuario: string
  setNome_usuario: React.Dispatch<React.SetStateAction<string>>
  nome_usuarioId: number
  setNome_usuarioId: React.Dispatch<React.SetStateAction<number>>
  outros_solicitantes: string
  setOutros_solicitantes: React.Dispatch<React.SetStateAction<string>>
  porcentagem: string
  setPorcentagem: React.Dispatch<React.SetStateAction<string>>
  representante_legal: boolean
  setRepresentante_legal: React.Dispatch<React.SetStateAction<boolean>>
  observacoes: string
  setObservacoes: React.Dispatch<React.SetStateAction<string>>
  onChangeUpload: (info: UploadChangeParam<UploadFile<any>>) => void
  fileList: any
  dummyRequest: (options: UploadRequestOption<any>) => void
  handlePreviewImage: (file: UploadFile<any>) => void
  onRemoveAssinatura: (file: UploadFile<any>) => boolean | void | Promise<boolean | void>
  uploadAssinatura: MutableRefObject<any>
  list_representantes: any[]
  setList_representantes: React.Dispatch<React.SetStateAction<any[]>>
  loading: boolean
  addRepresentante: Function
  editarRepresentante: Function
  dataEquipe: any[]
  update: number
  editar: boolean
  listRepresentante: Function
  loadingRepresentante: boolean
}

export const FormRepresentantesServiço: React.FC<PropsRepresentantes> = ({
  nome_usuario,
  setNome_usuario,
  nome_usuarioId,
  setNome_usuarioId,
  outros_solicitantes,
  setOutros_solicitantes,
  porcentagem,
  setPorcentagem,
  representante_legal,
  setRepresentante_legal,
  observacoes,
  setObservacoes,
  onChangeUpload,
  fileList,
  dummyRequest,
  handlePreviewImage,
  onRemoveAssinatura,
  uploadAssinatura,
  list_representantes,
  setList_representantes,
  loading,
  addRepresentante,
  editarRepresentante,
  dataEquipe,
  update,
  editar,
  listRepresentante,
  loadingRepresentante,
}) => {
  const [openUsuario, setOpenUsuario] = useState<boolean>(false)
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)

  const deletar = async (cod) => {
    setFake_loading(true)
    if (typeof cod === 'string') {
      setList_representantes((prev) => prev.filter((item) => item.cod !== cod))
    } else {
      const response = await delRepresentanteLegal(cod, update)

      if (response.status === 200) {
        successAlert(`Representante excluido com sucesso!`)
        listRepresentante()
      }
    }
    setTimeout(() => {
      setFake_loading(false)
    }, 2000)
  }

  function verificarPorcentagem(porcentagem) {
    if (Number(porcentagem) <= 100) {
      setPorcentagem(porcentagem)
    }
  }

  useEffect(() => {
    listRepresentante()
  }, [])

  return (
    <>
      <Box>
        <Switcher
          style={{ marginTop: '10px' }}
          label='Representante legal?'
          isChecked={representante_legal}
          trigger={setRepresentante_legal}
        />
        <div className='campo__dois__inputs'>
          <Select
            label='Nome usuário'
            value={nome_usuario}
            placeholder='Selecione o usuário'
            onChange={setNome_usuario}
            onChangeID={setNome_usuarioId}
            open={openUsuario}
            trigger={setOpenUsuario}
            items={dataEquipe}
            descricaoItem={'usuario_nome'}
            icon={faUser}
            idItem={'cod_func'}
            disabled={editar}
          />
          <Input
            label='Outros solicitantes (Os - análise de solo)'
            placeholder='Digite o solicitante'
            value={outros_solicitantes}
            onChange={setOutros_solicitantes}
            icon={faClipboardList}
          />
        </div>
        <Input
          label='Porcentagem'
          placeholder='0%'
          value={apenasNumeros(porcentagem)}
          icon={faPercent}
          onChange={(e) => verificarPorcentagem(e)}
          width='15%'
        />
        <TextArea label='Observação' value={observacoes} onChange={setObservacoes} maxHeight={40} />

        <div className='campo__dois__inputs' style={{ justifyContent: 'space-between' }}>
          <AntdCrop aspect={200 / 75} modalTitle='Recordar Imagem' showGrid>
            <Upload
              ref={uploadAssinatura}
              onRemove={onRemoveAssinatura}
              accept='image/jpeg, image/png'
              className='upload-list-inline'
              fileList={fileList}
              listType='picture'
              onChange={onChangeUpload}
              onPreview={handlePreviewImage}
              maxCount={1}
              multiple={false}
              customRequest={dummyRequest}
            >
              <Button type='primary' icon={<UploadOutlined />}>
                Assinatura
              </Button>
            </Upload>
          </AntdCrop>
          <ButtonCustom
            type='secondary'
            onClick={() => addRepresentante()}
            icon={<FontAwesomeIcon icon={editar ? faCheck : faPlus} />}
          >
            {editar ? 'Atualizar' : 'Inserir'}
          </ButtonCustom>
        </div>
      </Box>
      <HeaderTable
        itens={[
          { valor: 'Usuario', width: 'calc(100% - 510px)' },
          { valor: 'Solicitante', width: '130px' },
          { valor: 'Representante', width: '130px' },
          { valor: 'Participação', width: '130px' },
          { valor: 'Ações', width: '120px' },
        ]}
      />
      <Render condition={!loadingRepresentante}>
        <BodyTable
          style={{
            height: 'auto',
            position: 'relative',
            overflowX: 'hidden',
            overflowY: 'scroll',
            marginTop: -10,
          }}
        >
          {(list_representantes ?? []).map(
            ({
              cod,
              cod_usuario,
              usuario_nome,
              solicitante,
              representante,
              participacao,
              observacao,
            }) => {
              return (
                <RowTable key={cod} onDoubleClick={() => { }}>
                  <RowItem fontSize={13} width={'calc(100% - 504px)'}>
                    {usuario_nome}
                  </RowItem>
                  <RowItem fontSize={13} width={'130px'}>
                    {solicitante}
                  </RowItem>
                  <RowItem fontSize={13} width={'130px'}>
                    {representante ? 'Sim' : 'Não'}
                  </RowItem>
                  <RowItem fontSize={13} width={'130px'}>
                    {`${participacao} %`}
                  </RowItem>
                  <RowItem width={'120px'} gap={10}>
                    <DeleteButton
                      open={confirmar_exclusao && id_item_atual === cod}
                      trigger={setConfirmar_exclusao}
                      onTrigger={() => {
                        setId_item_atual(cod)
                        setNome_item_atual(usuario_nome)
                      }}
                      typeButtonTrigger='secondary'
                      loading={fake_loading}
                      message={`o item ${usuario_nome} será excluido!`}
                      deleteds={[usuario_nome]}
                      onDelete={() => {
                        deletar(cod)
                      }}
                      disabled={fake_loading}
                    />
                  </RowItem>
                </RowTable>
              )
            }
          )}

          <Render condition={list_representantes.length === 0}>
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Nenhum registro disponível!</>}
            />
          </Render>
        </BodyTable>
      </Render>
      <Render condition={loadingRepresentante}>
        <Carregando animation legenda='Carregando...' justifyContent='center' size='default' />
      </Render>
    </>
  )
}
